import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LoadingIcon, SelectableNFTList } from '@/components';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { useCallback, useState } from 'react';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const Search = ({ className, limit, tokens, notOwnedIds, loading, selectedTokenIds = [], onConfirm = noop, ...rest }) => {
    const t = useLocales();
    const [pickedIds, setPickedIds] = useState(selectedTokenIds);
    const handleConfirm = useCallback(() => {
        onConfirm(pickedIds);
    }, [onConfirm]);
    return (_jsxs("div", { className: classnames(className, styles.searchView), ...rest, children: [(() => {
                if (loading)
                    return _jsx("div", { className: styles.status, children: loading ? _jsx(LoadingIcon, { size: 48 }) : null });
                if (tokens.length)
                    return (_jsx(SelectableNFTList, { tokens: tokens, loading: loading, limit: limit, selectedTokenIds: pickedIds, onChange: setPickedIds }));
                return null;
            })(), notOwnedIds.length && !loading ? (_jsx("div", { className: classnames(styles.notfound, tokens.length ? undefined : styles.expand), children: t('Token ID {ids} does not exist or belong to you.', {
                    ids: notOwnedIds
                        .map((id) => `<span class="${styles.hightlight}">#${id}</span>`)
                        .join(','),
                }) })) : null, _jsx("div", { className: styles.buttonGroup, children: _jsx(Button, { fullWidth: true, onClick: handleConfirm, colorScheme: "primary", disabled: pickedIds.length === 0 || tokens.length === 0, children: t('Add') }) })] }));
};
